import React, { useEffect, useState } from "react"
import Sidebar from "components/VerticalLayout/Sidebar"
import Header from "components/VerticalLayout/Header"
import Footer from "components/VerticalLayout/Footer"
import "../../assets/css/style.css"
import { Link, useNavigate } from "react-router-dom"
import { Button } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import "react-toastify/dist/ReactToastify.css"

import { useFormik } from "formik"
import * as Yup from "yup"
import { getHeader, postRequest } from "common/Constants"
import axios from "axios"
import Select from "react-select"

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    height: "34px", // Adjust the height to your preference
  }),
}

const Addfarmerpayment = () => {
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const reactAppUrl = process.env.REACT_APP_ALLURL

  const [farmer, setFarmer] = useState([])
  const [personName, setPersonName] = useState([])
  const getAllFarmers = async () => {
    const farmerResponse = await axios.get(`${reactAppUrl}/dropdownFarmer`)
    setFarmer(farmerResponse.data.data)
    const mappedData = farmerResponse.data.data.map(item => ({
      value: item.farmer_id,
      label: item.name,
    }))
    setPersonName(mappedData)
  }

  const [farmerData, setFarmerData] = useState([])
  const [farmerId, setFarmerId] = useState([])
  const handleUsernameChange = async event => {
    validation.handleChange(event)
    const selectedName = event.target.value
    setFarmerId(event.target.value)

    const responseDetail = await axios.get(
      `${reactAppUrl}/FarmerDetail?farmer_id=${selectedName}`,
      getHeader
    )
    setFarmerData(responseDetail.data.data)
  }
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      Name: "",
      Date: "",
      Amount: "क्रेडिट",
      Paymentstatus: "",
      Money: "",
      Hetu: "",
      Note: "",
    },
    validationSchema: Yup.object({
      Name: Yup.string().required("कृपया आपले नाव टाका"),

      Date: Yup.string().required("कृपया तारीख टाका"),

      Amount: Yup.string().required("कृपया पेमेंट प्रकार टाका"),
      Paymentstatus: Yup.string().required("कृपया पेमेंट पेमेंट पद्धत टाका"),
      Money: Yup.string().required("कृपया रक्कम टाका"),
      Hetu: Yup.string().required("कृपया हेतू टाका"),
      Note: Yup.string().required("कृपया नोट टाका"),
    }),
    onSubmit: async values => {

      try {
        let data = {
          id: values.Name,
          date: values.Date,
          payment_mode: 2,
          payment_type: values.Paymentstatus,
          amount: values.Money,
          reason: values.Hetu,
          notes: values.Note,
        }
        setIsLoading(true)
        const responseData = await postRequest(`farmerPayment`, data)
        setIsLoading(false)
        if (responseData && responseData.status == 200) {
          // toast.success(responseData.data.message)
          navigate("/farmerpayment")
        }
      } catch (error) {
        setIsLoading(false)
        console.log(error)
      }
    },
  })

  useEffect(() => {
    getAllFarmers()
  }, [])

  useEffect(() => {
    // While detailInvoice page is active, the invoice tab must also activated
    let element = document.getElementById("paymentlist")
    let element2 = document.getElementById("payment-ul")
    if (element) {
      element.classList.add("mm-active") // Add the 'active' class to the element
    }
    if (element2) {
      element2.classList.add("mm-show")
    }
    return () => {
      if (element) {
        element.classList.remove("mm-active") // remove the 'active' class to the element when change to another page
        element2.classList.remove("mm-show") // remove the 'show' class to the element when change to another page
      }
    }
  }, [])

  return (
    <div>
      <div id="layout-wrapper">
        <Header></Header>
        <Sidebar></Sidebar>

        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <Breadcrumbs
                title="डॅशबोर्ड"
                breadcrumbItem="नवीन शेतकरी पेमेंट"
              />

              <div className="row">
                <div className="col" style={{ padding: "0" }}>
                  <div className="card">
                    <div className="card-body">
                      <form
                        className="needs-validation mt-4"
                        onSubmit={e => {
                          e.preventDefault()
                          validation.handleSubmit()
                          return false
                        }}
                      >
                        <div className="row mb-3">
                          <label className="col-md-2 col-form-label">
                            नाव*
                          </label>
                          <div className="col-md-10">
                            {/* <select
                              id="formrow-InputState variety"
                              name="Name"
                              className="form-select"
                              // onChange={validation.handleChange}
                              onChange={handleUsernameChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.Name}
                            >
                              <option value="">Select</option>
                              {farmer &&
                                farmer.map((farmers, index) => {
                                  return (
                                    <option
                                      value={farmers.farmer_id}
                                      key={index}
                                    >
                                      {farmers.name}
                                    </option>
                                  )
                                })}
                            </select> */}

                            <Select
                              styles={customStyles}
                              id="tours"
                              name="tours"
                              className="basic-single"
                              classNamePrefix="select"
                              options={personName}
                              onChange={selectedOption => {
                                validation.setFieldValue(
                                  "Name",
                                  selectedOption ? selectedOption.value : ""
                                )
                              }}
                              onBlur={e => {
                                validation.handleBlur(e)
                              }}
                              value={personName.find(
                                option =>
                                  option.value === validation.values.tours
                              )}
                            />

                            {validation.touched.Name &&
                            validation.errors.Name ? (
                              <span className="error">
                                {validation.errors.Name}
                              </span>
                            ) : null}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <label className="col-md-2 col-form-label">
                            तारीख*
                          </label>
                          <div className="col-md-10">
                            {/* <DatePicker
                              selected={startDate}
                              onChange={date => setStartDate(date)}
                              className="form-control"
                              dateFormat="d-MM-yyyy"
                              placeholderText="Select date"
                              required="required"
                            /> */}

                            <input
                              className="form-control"
                              type="date"
                              name="Date"
                              id="example-month-input month"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.Date}
                            />
                            {validation.touched.Date &&
                            validation.errors.Date ? (
                              <span className="error">
                                {validation.errors.Date}
                              </span>
                            ) : null}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <label className="col-md-2 col-form-label">
                            पेमेंट प्रकार*
                          </label>
                          <div className="col-md-10">
                            <input
                              id="amount"
                              name="Amount"
                              className="form-control"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.Amount}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <label className="col-md-2 col-form-label">
                            पेमेंट पद्धत(कॅश/बँकिंग)*
                          </label>
                          <div className="col-md-10">
                            <select
                              id="formrow-InputState payment"
                              name="Paymentstatus"
                              className="form-select"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.Paymentstatus}
                            >
                              <option value="">Select</option>
                              <option value="1">कॅश</option>
                              <option value="2">बँकिंग</option>
                            </select>
                            {validation.touched.Paymentstatus &&
                            validation.errors.Paymentstatus ? (
                              <span className="error">
                                {validation.errors.Paymentstatus}
                              </span>
                            ) : null}
                          </div>
                        </div>
                        <div className="row mb-3">
                          <label className="col-md-2 col-form-label">
                            रक्कम*
                          </label>
                          <div className="col-md-10">
                            <input
                              id="money"
                              name="Money"
                              className="form-control"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.Money}
                            />
                            {validation.touched.Money &&
                            validation.errors.Money ? (
                              <span className="error">
                                {validation.errors.Money}
                              </span>
                            ) : null}
                          </div>
                        </div>
                        <div className="row mb-3">
                          <label className="col-md-2 col-form-label">
                            हेतू*
                          </label>
                          <div className="col-md-10">
                            <input
                              id="Hetu"
                              name="Hetu"
                              className="form-control"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.Hetu}
                            />
                            {validation.touched.Hetu &&
                            validation.errors.Hetu ? (
                              <span className="error">
                                {validation.errors.Hetu}
                              </span>
                            ) : null}
                          </div>
                        </div>
                        <div className="row mb-3">
                          <label className="col-md-2 col-form-label">नोट*</label>
                          <div className="col-md-10">
                            <textarea
                              id="Note"
                              name="Note"
                              className="form-control"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.Note}
                            />
                            {validation.touched.Note &&
                            validation.errors.Note ? (
                              <span className="error">
                                {validation.errors.Note}
                              </span>
                            ) : null}
                          </div>
                        </div>

                        {/* <Row className="mb-3">
                    <label
                      htmlFor="example-number-input"
                      className="col-md-2 col-form-label"
                    >
                      Number
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control"
                        type="number"
                        defaultValue="42"
                        id="example-number-input"
                      />
                    </div>
                  </Row> */}

                        <div
                          className="row mb-3"
                          style={{ justifyContent: "space-between" }}
                        >
                          <div
                            className="col-md-2 col-5"
                            style={{ textAlign: "left" }}
                          >
                            <Link
                              to="/farmerpayment"
                              className="btn btn-danger"
                            >
                              मागे जा
                            </Link>
                          </div>
                          <div
                            className="col-md-2 col-7"
                            style={{ textAlign: "right" }}
                          >
                            <Button
                              color="primary"
                              type="submit"
                              disabled={isLoading}
                            >
                              {isLoading
                                ? " प्रस्तुत करत आहोत"
                                : "प्रस्तुत करणे"}
                            </Button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
  )
}

export default Addfarmerpayment
